/* bz-home-modular.js — H-module behaviour (quiz, toggles). Dependency-free. US build.
   Session 52E 2026-07-05. Scoped to the .bzh wrapper; safe if multiple sections ever coexist (first wins). */
(function () {
  /* Idempotency guard (2026-07-07 T-7c2647): this section emits its <script> once PER instance, and the
     starter PDP renders TWO bz-home-modular sections → the file executes twice. Without this guard every
     handler (flip, quiz, buy-box, mech) binds twice; a double-bound flip toggles on→off per user click and
     never reveals. Run the whole init exactly once per page. */
  if (window.__bzHomeModularInit) return;
  window.__bzHomeModularInit = true;
  var root = document.querySelector('.bzh');
  if (!root) return;

  var p = window.location.search;
  if (p.indexOf('quiz') > -1 || p.indexOf('open=1') > -1) root.classList.add('quiz-open');
  if (p.indexOf('arm=control') > -1) root.classList.add('arm-control');

  function openQuiz() {
    root.classList.add('quiz-open');
    var qp = root.querySelector('.quizpanel');
    if (qp) qp.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  ['bzhQuizToggle', 'bzhQuizToggle2'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('click', function (e) { e.preventDefault(); openQuiz(); });
  });

  /* flip-reveal cards (fix-run 2026-07-06 item 7; multi-root fix 2026-07-07 T-7c2647) — placed BEFORE
     the quiz early-return below so it runs on templates without a quiz panel (e.g. the starter PDP).
     The starter PDP renders TWO .bzh sections (starter-head + starter-below); arm EVERY root that
     holds flip cards, not just document.querySelector('.bzh') — otherwise the body section's principle
     + timeline cards never collapse and render both faces stacked. */
  Array.prototype.forEach.call(document.querySelectorAll('.bzh'), function (bzh) {
    var flips = bzh.querySelectorAll('.flip');
    if (!flips.length) return;
    bzh.classList.add('flip-armed');
    Array.prototype.forEach.call(flips, function (f) {
      f.setAttribute('aria-expanded', 'false');
      f.addEventListener('click', function () {
        var on = f.classList.toggle('on');
        f.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });
  });

  /* ---- Find Your Formula (paid-safe; email-at-result; US prices) ---- */
  var QUIZ = [
    { q: 'What does your day ask the most of you?', a: [['Deep, sustained concentration', 'pro'], ['Drive & motivation to begin', 'pro'], ['Staying calm under pressure', 'elite']] },
    { q: 'When does your focus tend to dip?', a: [['Mid-work or study', 'pro'], ['The mid-afternoon slump', 'pro'], ['High-pressure stretches', 'elite']] },
    { q: 'What would make the biggest difference right now?', a: [['Getting more done', 'pro'], ['Feeling motivated to start', 'pro'], ['Feeling calm & clear', 'elite']] },
    { q: 'How strong do you want to start?', a: [['Give me the strongest', 'pro'], ['Balanced, for every day', 'pro'], ["Mildest — I'm new to this", 'original']] }
  ];
  var RES = {
    pro: { n: 'FOCUS PRO™', p: '$40', u: '/products/brainzyme-professional-stronger-formula', w: 'Strong, all-day focus and drive — dopamine-pathway support for concentration and motivation.' },
    elite: { n: 'FOCUS ELITE™', p: '$65', u: '/products/brainzyme-elite-3-in-1-formula', w: 'Calm, stress-free focus — GABA-pathway support to stay clear and composed under pressure.' },
    original: { n: 'FOCUS ORIGINAL™', p: '$25', u: '/products/brainzyme-original-milder-formula', w: "A gentle everyday lift — our mildest formula, ideal if you're new to focus support." }
  };
  var qi = 0, qans = [];
  var qprogEl = root.querySelector('.qprog'), qbodyEl = root.querySelector('#bzhQBody');
  if (!qprogEl || !qbodyEl) return;

  function qprog(all) {
    var h = '';
    for (var i = 0; i < QUIZ.length; i++) h += '<i' + ((all || i <= qi) ? ' class="on"' : '') + '></i>';
    qprogEl.innerHTML = h;
  }
  function qRender() {
    qprog(false);
    var Q = QUIZ[qi], sel = qans[qi], opts = '';
    for (var i = 0; i < Q.a.length; i++) {
      opts += '<div class="qopt' + (sel === i ? ' sel' : '') + '" data-i="' + i + '"><span>' + (sel === i ? '●' : '○') + '</span> ' + Q.a[i][0] + '<span class="ck">✓</span></div>';
    }
    qbodyEl.innerHTML = '<div class="qq">' + (qi + 1) + '. ' + Q.q + '</div><div class="qopts">' + opts + '</div>' +
      '<div class="qnav"><button type="button" class="qback"' + (qi === 0 ? ' hidden' : '') + '>← Back</button><button type="button" class="qnext"' + (sel == null ? ' disabled' : '') + '>' + (qi === QUIZ.length - 1 ? 'See my result →' : 'Next →') + '</button></div>';
    Array.prototype.forEach.call(qbodyEl.querySelectorAll('.qopt'), function (o) {
      o.addEventListener('click', function () { qans[qi] = +o.getAttribute('data-i'); qRender(); });
    });
    var nb = qbodyEl.querySelector('.qnext'); if (nb) nb.addEventListener('click', qNext);
    var bb = qbodyEl.querySelector('.qback'); if (bb) bb.addEventListener('click', function () { qi--; qRender(); });
  }
  function qNext() {
    if (qans[qi] == null) return;
    if (qi < QUIZ.length - 1) { qi++; qRender(); } else { qResult(); }
  }
  function qResult() {
    var s = { pro: 0, elite: 0, original: 0 };
    for (var i = 0; i < QUIZ.length; i++) if (qans[i] != null) s[QUIZ[i].a[qans[i]][1]]++;
    var win = 'pro', best = -1;
    for (var k in s) if (s[k] > best) { best = s[k]; win = k; }
    if (qans[3] != null && QUIZ[3].a[qans[3]][1] === 'original') win = 'original';
    var R = RES[win];
    qprog(true);
    qbodyEl.innerHTML = '<div class="qresult"><div class="rmatch">Your match</div><div class="rsku">' + R.n + '</div><div class="rprice">' + R.p + '</div>' +
      '<div class="rwhy">' + R.w + '</div>' +
      '<div class="qunlock"><span class="u10txt">🔓 10% off unlocked — </span>enter your email for your personal plan<span class="u10txt"> and your 10% code</span>.</div>' +
      '<div class="qemail"><input type="email" placeholder="you@email.com" aria-label="Email address"><button type="button">Get my plan →</button></div>' +
      '<a class="qcta" href="' + R.u + '">Start with ' + R.n + ' · ' + R.p + ' →</a>' +
      '<div class="qsmall"><a class="requiz" style="text-decoration:underline;cursor:pointer">retake the quiz</a></div></div>';
    var rq = qbodyEl.querySelector('.requiz');
    if (rq) rq.addEventListener('click', function () { qi = 0; qans = []; qRender(); });
    /* 10%-unlock payoff: show the market code + Copy button the instant the email lands
       (backend capture is wired at go-live; the code display works standalone) */
    var ge = qbodyEl.querySelector('.qemail button');
    if (ge) ge.addEventListener('click', function () {
      var inp = qbodyEl.querySelector('.qemail input');
      var em = inp ? inp.value.replace(/^\s+|\s+$/g, '') : '';
      if (!em || em.indexOf('@') < 1 || em.indexOf('.') < 0) { if (inp) { inp.focus(); inp.setAttribute('aria-invalid', 'true'); } return; }
      try { localStorage.setItem('bzh_quiz_email', em); } catch (e) {}
      var code = root.getAttribute('data-discount-code') || 'WELCOME10';
      var un = qbodyEl.querySelector('.qunlock'), qe = qbodyEl.querySelector('.qemail');
      if (un) un.style.display = 'none';
      if (qe) qe.style.display = 'none';
      var cp = document.createElement('div');
      cp.className = 'qcode';
      cp.innerHTML = '<div class="qcode-label">Your 10% code</div>' +
        '<div class="qcode-row"><span class="qcode-val">' + code + '</span><button type="button" class="qcopy">Copy code</button></div>' +
        '<div class="qcode-note">Use it at checkout — your personal plan is on its way.</div>';
      var cta = qbodyEl.querySelector('.qcta');
      if (cta) cta.parentNode.insertBefore(cp, cta); else qbodyEl.appendChild(cp);
      cp.querySelector('.qcopy').addEventListener('click', function () {
        var b = this;
        function done() { b.textContent = 'Copied ✓'; b.classList.add('ok'); setTimeout(function () { b.textContent = 'Copy code'; b.classList.remove('ok'); }, 2400); }
        function fallback() {
          var t = document.createElement('textarea'); t.value = code; t.style.position = 'fixed'; t.style.opacity = '0';
          document.body.appendChild(t); t.select();
          try { if (document.execCommand('copy')) done(); } catch (e) {}
          document.body.removeChild(t);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback);
        else fallback();
      });
    });
  }
  qRender();

  /* mechanism expander (present on some variants) */
  var mb = document.getElementById('bzhMechBtn');
  if (mb) mb.addEventListener('click', function () { root.classList.toggle('mech-open'); });
})();

/* motion system — only when the section root carries .bzh--motion (v6-7/v6-8) */
(function () {
  var root = document.querySelector('.bzh--motion');
  if (!root || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        if (e.target.classList.contains('mechsteps')) e.target.parentElement.classList.add('mech-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.18 });
  var sel = 'section .eyebrow, section h2, .paths .path, .rgrid > div, .ingcard, .founder, .offer-list, .pricerow, .wagrid > div, .time > div, .rcard2, .msplit img, .figband, .mechsteps';
  var i = 0;
  root.querySelectorAll(sel).forEach(function (el) {
    if (!el.classList.contains('mechsteps')) el.classList.add('rv');
    if (i % 3 === 1) el.classList.add('rv2');
    if (i % 3 === 2) el.classList.add('rv3');
    i++;
    io.observe(el);
  });
  var h1 = root.querySelector('.bzh-h1');
  if (h1) {
    h1.innerHTML = h1.innerHTML.split(/\s+/).map(function (w, j) {
      return '<span class="hw" style="animation-delay:' + (0.08 * j + 0.1) + 's">' + w + '</span>';
    }).join(' ');
  }
  var imgs = [].slice.call(root.querySelectorAll('.msplit img, .hero figure img, .hero figure video'));
  imgs.forEach(function (im) { im.classList.add('px-img'); });
  var tick = false;
  window.addEventListener('scroll', function () {
    if (tick) return; tick = true;
    requestAnimationFrame(function () {
      var wh = window.innerHeight;
      imgs.forEach(function (im) {
        var r = im.getBoundingClientRect();
        var p = (r.top + r.height / 2 - wh / 2) / wh;
        im.style.transform = 'translateY(' + (p * -18) + 'px)';
      });
      tick = false;
    });
  }, { passive: true });
})();

/* Chat launcher clearance — CALM version (Calum: no jitter).
   One-time <style> injected into the widget's open shadowRoot: transform lifts it
   (the widget only rewrites `bottom`, never transform, so nothing fights/jumps). */
(function () {
  function styleWidget() {
    var host = document.querySelector('n8nchatui-popup, flowise-chatbot');
    if (!host || !host.shadowRoot || host.shadowRoot.getElementById('bzh-chat-style')) return;
    var st = document.createElement('style');
    st.id = 'bzh-chat-style';
    st.textContent = [
      'button{transform:translateY(-84px) !important;transition:none !important}',
      '@media (max-width:860px){button{width:60px !important;height:60px !important}button img{width:60px !important;height:60px !important}}',
      'button:not(:first-of-type){display:none !important}'
    ].join('');
    host.shadowRoot.appendChild(st);
  }
  setInterval(styleWidget, 1200);
})();


/* Starter Set buy-box (product templates) — native selling-plan picker driving Seal subscription plans.
   Default = Subscribe & Save, 30-day plan (Calum: 1-month subscription default). */
(function () {
  var form = document.getElementById('bzbbForm');
  if (!form) return;
  var PLANS = {};
  try { PLANS = JSON.parse(document.getElementById('bzbbPlans').textContent); } catch (e) {}
  var vid = document.getElementById('bzbbVariantId');
  var pid = document.getElementById('bzbbPlanId');
  var freq = document.getElementById('bzbbFreq');
  var subP = document.getElementById('bzbbSubPrice');
  var oneP = document.getElementById('bzbbOnePrice');
  var buyNow = document.getElementById('bzbbBuyNow'); /* B3 2026-07-12: secondary straight-checkout anchor */
  /* B1/B2 BOGO (2026-07-12): the free-sample automatic BXGY zeroes the sample ONLY when both
     lines are in cart (no auto-add option on the Admin API — capability-checked). Map = 1-mo
     one-time variant -> its free sample variant (PRO 1-mo -> ELITE sample, ELITE 1-mo -> PRO
     sample). 3-mo/6-mo variants are absent by design — a multi-item cart there would CHARGE
     the sample. S&S is untouched (Seal bypasses the cart; samples stay one-time-only). */
  /* Union map across all 4 stores (variant IDs are store-scoped, so only the current
     store's keys can ever match): US / UK / DE / FR pairs. */
  /* UK/DE/FR pairs removed 2026-10 (T-2343a5): their BXGY expired 19 Jul, so a gift-add here would charge the sample. */
  var BOGO_SAMPLES = {
    '39256090771648': '43244478038208', '39257034883264': '43244486557888'
  };
  var lastV = null;
  /* Money format is template-driven for ports: form[data-money-fmt] e.g. '£{v}' or '{v} €'
     (a '€' fmt switches to comma decimals). Absent/blank -> US default '${v}'. */
  function money(c) {
    var n = (c / 100).toFixed(2);
    var wrap = form && form.closest ? form.closest('[data-money-fmt]') : null;
    var fmt = (wrap && wrap.getAttribute('data-money-fmt')) || '';
    if (!fmt) return '$' + n;
    if (fmt.indexOf('€') !== -1) n = n.replace('.', ',');
    return fmt.replace('{v}', n);
  }
  function currentVariant() { var r = form.querySelector('input[name="bzbb-variant"]:checked'); return r ? r.value : vid.value; }
  function subSelected() { var r = form.querySelector('input[name="bzbb-ptype"]:checked'); return r && r.value === 'sub'; }
  function fillFreq(v) {
    var list = PLANS[v] || [];
    freq.innerHTML = '';
    list.forEach(function (p) {
      var days = (p.name.match(/(\d+)[- ]Day/i) || [])[1];
      var o = document.createElement('option');
      o.value = p.plan; o.textContent = (days ? days + ' days' : p.name); o.setAttribute('data-price', p.price);
      freq.appendChild(o);
    });
    for (var i = 0; i < freq.options.length; i++) {
      if (freq.options[i].textContent.indexOf('30 ') === 0) { freq.selectedIndex = i; break; }
    }
  }
  function sync() {
    var v = currentVariant();
    if (v !== lastV) { fillFreq(v); lastV = v; }
    vid.value = v;
    var opt = freq.options[freq.selectedIndex];
    if (opt) subP.textContent = money(+opt.getAttribute('data-price'));
    var chosen = form.querySelector('input[name="bzbb-variant"]:checked');
    var plbl = chosen && chosen.closest('.bzbb-v').querySelector('.p');
    if (plbl) oneP.textContent = plbl.textContent;
    pid.value = (subSelected() && opt) ? opt.value : '';
    /* B3 (2026-07-12): recompute Buy Now href per selection — one-time → /cart/ permalink,
       S&S → Seal checkout route (both PRE-CHECK-verified; relative form live-verified on the
       storefront domain). Defensive if(node) guard — shared JS serves sibling surfaces (R1c). */
    if (buyNow) {
      /* B2 BOGO (2026-07-12): one-time + 1-mo -> multi-item permalink (sample rides along so the
         BXGY zeroes it at checkout); any other one-time variant keeps the single-item permalink. */
      buyNow.href = (subSelected() && opt)
        ? '/a/subscriptions/checkout/' + v + ':1:' + opt.value + '?clear=false'
        : (BOGO_SAMPLES[v] ? '/cart/' + v + ':1,' + BOGO_SAMPLES[v] + ':1' : '/cart/' + v + ':1');
    }
    /* renewal disclosure (fix-run 2026-07-06 item 3; B2 2026-07-12: the .bzbb-renew paragraph is
       stripped from THIS section's markup, but the toggle is KEPT per R1c — class-scoped, crash-proof,
       and sibling surfaces rendering .bzbb-renew still get correct show/hide. */
    form.classList.toggle('bzbb-onetime', !subSelected());
    Array.prototype.forEach.call(form.querySelectorAll('.bzbb-v, .bzbb-p'), function (l) {
      l.classList.toggle('sel', l.querySelector('input').checked);
    });
  }
  form.addEventListener('change', sync);
  sync();
  /* B1 ATC gift-add (R1a-iii, 2026-07-12): on a qualifying 1-mo ONE-TIME add-to-cart, add the
     free-sample line first so drawer-cart orders also qualify for the BXGY. Defensive: only
     fires when (form && one-time && 1-mo && fetch available); any fetch failure still falls
     through to the untouched native/theme submit, so ATC can never break. */
  var bogoBypass = false;
  form.addEventListener('submit', function (e) {
    if (bogoBypass) { bogoBypass = false; return; }
    var v = String(currentVariant());
    if (!form || subSelected() || !BOGO_SAMPLES[v] || !window.fetch) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: +BOGO_SAMPLES[v], quantity: 1 }] })
    }).catch(function () {}).then(function () {
      bogoBypass = true;
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    });
  }, true);
})();

/* figband tap-to-zoom (2026-07-11 A1/A2 gap fixes; HARDENED 2026-07-12 T-309f0e P1+P2):
   keyboard/ARIA path (Enter/Space open, Esc close, focus move + restore), ONE shared close(),
   class-scoped scroll lock (html/body .bzh-zoom-lock — added in open(), removed in close()),
   overscroll containment + touch-action in CSS, "tap anywhere to close" affordance line.
   Own idempotency guard — delegated listeners bind once even with multiple section instances. */
(function () {
  if (window.__bzhZoomInit) return; window.__bzhZoomInit = true;
  var overlay = null, opener = null;
  function onKey(e) {
    if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); close(); }
  }
  function close() {
    if (!overlay) return;
    overlay.remove(); overlay = null;
    document.documentElement.classList.remove('bzh-zoom-lock');
    document.body.classList.remove('bzh-zoom-lock');
    document.removeEventListener('keydown', onKey, true);
    if (opener && opener.focus) { try { opener.focus(); } catch (err) {} }
    opener = null;
  }
  function open(img) {
    if (overlay) close();
    opener = img;
    var ov = document.createElement('div');
    ov.className = 'bzh-zoom-ov';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', img.alt || 'Enlarged image');
    ov.setAttribute('tabindex', '-1');
    var hint = document.createElement('div');
    hint.className = 'bzh-zoom-close';
    hint.textContent = 'Tap anywhere to close ✕';
    var big = document.createElement('img');
    big.src = img.currentSrc || img.src; big.alt = img.alt || '';
    ov.appendChild(hint); ov.appendChild(big);
    ov.addEventListener('click', close);
    document.body.appendChild(ov);
    overlay = ov;
    document.documentElement.classList.add('bzh-zoom-lock');
    document.body.classList.add('bzh-zoom-lock');
    document.addEventListener('keydown', onKey, true);
    try { ov.focus(); } catch (err) {}
  }
  function findImg(e) {
    return e.target && e.target.closest ? e.target.closest('.bzh .figband img') : null;
  }
  document.addEventListener('click', function (e) {
    var img = findImg(e); if (img) open(img);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.keyCode !== 13 && e.keyCode !== 32) return;
    var img = findImg(e); if (!img) return;
    e.preventDefault(); open(img);
  });
})();

/* gbadge dropdown Esc-close (QC-wave D1, 2026-07-12): native <details> has no Esc affordance —
   mirror the zoom overlay's keyboard behaviour. Focus returns to the summary. */
(function () {
  if (window.__bzhGbadgeEsc) return; window.__bzhGbadgeEsc = true;
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;
    var dd = document.querySelector('details.bzh-gbadge--dd[open]');
    if (!dd) return;
    dd.removeAttribute('open');
    var s = dd.querySelector('summary');
    if (s && s.focus) { try { s.focus(); } catch (err) {} }
  });
})();
